import { fetchWithAuth } from '../utils/fetchWithAuth';

export const pushTokenApi = {
  register: async (pushToken: string, deviceName?: string) => {
    const response = await fetchWithAuth('push-notifications/register', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ pushToken, deviceName }),
    });

    const data = await response.json();

    if (!response.ok || !data.success) {
      throw new Error(data.error || 'Failed to register push token');
    }

    return data;
  },

  unregister: async (pushToken: string) => {
    const response = await fetchWithAuth('push-notifications/unregister', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ pushToken }),
    });

    const data = await response.json();

    if (!response.ok || !data.success) {
      throw new Error(data.error || 'Failed to unregister push token');
    }

    return data;
  },
};
